import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggerService } from '../services/logger/logger.service';
import { tap } from 'rxjs';
import { LogsType } from '../../shared/constants/logs-type.enum';

export const performanceInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const className = 'performanceInterceptor';
  const logger = inject(LoggerService);

  const startTime = Date.now();

    return next(req).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            const endTime = Date.now();
            const duration = endTime - startTime;
            logger.logMessage(LogsType.INFO, className, '', `URL: ${req.url} Tempo: ${duration}ms`);
          }
        },
        error: () => {
          const endTime = Date.now();
          const duration = endTime - startTime;
          logger.logMessage(LogsType.INFO, className, '', `Erro - URL: ${req.url} Tempo: ${duration}ms`);
        }
      })
    );
};
